import { render } from "./SocialIcons.vue?vue&type=template&id=67149a9d"
const script = {}

import "./SocialIcons.vue?vue&type=style&index=0&id=67149a9d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__